import Api from "../../config/Api";
import { Favorite } from "./type";

const PATH = "/favorites";

async function getFavorites(page = 1, signal?: AbortSignal): Promise<any> {
  const response = await Api.get(`${PATH}`, {
    signal,
    params: { page, perPage: 20 },
  });

  return response.data;
}

async function getTotalFavorites(signal?: AbortSignal): Promise<any> {
  const response = await Api.get(`${PATH}/count`, { signal });

  return response.data;
}

async function addToFavorite(favorite: Favorite): Promise<void> {
  const response = await Api.post(PATH, favorite);

  return response.data;
}

async function removeFavorite(_id: string): Promise<void> {
  const response = await Api.delete(`${PATH}/${_id}`);

  return response.data;
}

async function isFavorite(productId: string): Promise<void> {
  const response = await Api.get(PATH, {
    params: { productId },
  });

  return response.data;
}

export default {
  addToFavorite,
  getFavorites,
  getTotalFavorites,
  removeFavorite,
  isFavorite,
};
